import React, { useState, useEffect } from 'react';
import { Button, Col, message, Form, Row, Table, Tag, Tooltip } from 'antd';
import {
  FileDoneOutlined,
  ArrowLeftOutlined,
  CheckCircleOutlined,
  SendOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import logo from '../../Assets/img/logo.jpg';
import IMG1 from '../../Assets/img/IMG1.jpg';
import IMG2 from '../../Assets/img/IMG2.jpg';
import IMG3 from '../../Assets/img/IMG3.jpg';
import IMG4 from '../../Assets/img/IMG4.jpg';
import { SearchBar } from '../Atoms/SearchBar';
import { aSearchElements, oInitState, requiredFields } from './TicketConstants';
import { generateQueries } from '../../Utils/query';
import { useFetchOrdersWithApiKey } from '../../Hooks/Order.hook';
import { TicketActions } from './TicketActions';
import {
  useSaveInvoicesWithApiKey,
  useFetchOneBranchWithApiKey,
  useFetchClientsWithApiKey,
  useSendInvoicesWithApiKey,
  useStampInvoicesWithApiKey,
} from '../../Hooks';
import {
  process,
  FIND_KEY,
  UPDATE_KEY,
  SAVE_KEY,
  GET_KEY,
} from '../../Service/Api';
import moment from 'moment';
import { useNavigation } from '../../Hooks';
import { codeMap } from '../../Utils/codeMap';

export const TicketTable = () => {
  let res;
  let resBranch;
  let cadena = window.location.pathname.replace('/tickets/', '').split('&');
  const rfc = cadena[0];
  const branch_id = cadena[1];
  const [branch, setBranch] = useState();
  const [client, setClient] = useState();
  const [search, setSearch] = useState(oInitState);
  const [orders, loading, change, updater] = useFetchOrdersWithApiKey(
    `branch_id=${branch_id}`
  );
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [modalLoading2, setModalLoading2] = useState(false);
  const [selected, setSelected] = useState({});
  const [formRef] = Form.useForm();
  const [searchFlag, setSearchFlag] = useState(false);
  const [, nav] = useNavigation();

  const aColumns = [
    {
      dataIndex: 'folio',
      title: 'Folio',
    },
    {
      dataIndex: 'fecha',
      title: 'Fecha Orden',
      render: fecha => (
        <>
          {new Date(fecha).toLocaleString('es-MX', {
            timeZone: 'America/Mexico_City',
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          })}
        </>
      ),
    },
    {
      dataIndex: 'total_bruto',
      title: 'Subtotal',
      render: total_bruto => <>$ {total_bruto && total_bruto.toFixed(2)}</>,
    },
    {
      dataIndex: 'total_neto',
      title: 'Total Neto',
      render: total_neto => <>$ {total_neto && total_neto.toFixed(2)}</>,
    },
    {
      dataIndex: 'id',
      title: 'Acciones',
      render: (_, row) => {
        const fechaOrder = new Date(row.fecha);
        const hsDifference =
          (new Date().getTime() - fechaOrder.getTime()) / (1000 * 60 * 60);
        const has72HsOrMore = hsDifference > 72;
        if (row.status_invoice === 0) {
          if (has72HsOrMore) {
            return (
              <span style={{ color: '#d32f2f', fontWeight: 'bold' }}>
                No se puede facturar (pasaron más de 72h)
              </span>
            );
          }

          return (
            <Row>
              {row.status === 1 ? (
                <Button
                  onClick={() => {
                    setSelected(row);
                    setModal(true);
                  }}
                >
                  <FileDoneOutlined />
                  Facturar
                </Button>
              ) : (
                <>Cancelado</>
              )}
            </Row>
          );
        }

        return (
          <Row gutter={[8, 8]}>
            <Col span={12}>
              <Tooltip title="Orden Facturada">
                <Tag color="#7444C8">
                  <CheckCircleOutlined />
                </Tag>
              </Tooltip>
            </Col>
            <Col span={12}>
              <Tooltip title="Orden Facturada">
                <Button
                  danger
                  size="small"
                  onClick={() => {
                    setSelected(row);
                    setModal2(true);
                  }}
                >
                  <SendOutlined />
                </Button>
              </Tooltip>
            </Col>
          </Row>
        );
      },
    },
  ];

  useEffect(async () => {
    resBranch = await useFetchOneBranchWithApiKey(branch_id);
    setBranch(resBranch);
    res = await useFetchClientsWithApiKey(`rfc=${rfc}`);
    setClient(res.data.data[0]);
  }, []);

  const handleReset = () => {
    setSearchFlag(false);
    setSearch(oInitState);
    change();
  };

  const generateCode = long => {
    let result = '';
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < long) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  };

  const handleSubmit = async values => {
    setModalLoading2(true);
    try {
      console.log('selected TEST', selected);
      console.log('values TEST', values);
      let currentOrder;
      let isFullInvoice = selected.total_neto === values.total;

      if (isFullInvoice) {
        // Facturación total: usar orden original SIN marcarla como facturada aún
        console.log('enter if TEST - Full invoice');
        currentOrder = { data: selected };
      } else {
        console.log('enter else TEST - Partial invoice');
        // Facturación parcial: actualizar orden original y crear nueva orden
        const updatedBruto = Number(
          (selected.total_bruto - values.total / 1.16).toFixed(2)
        );
        const updatedTotal = Number(
          (selected.total_neto - values.total).toFixed(2)
        );
        const updatedOrder = await process(
          UPDATE_KEY,
          'orders',
          { total_bruto: updatedBruto, total_neto: updatedTotal },
          { id: selected.id }
        );
        console.log('updateOldOrder', updatedOrder);

        // Crear nueva order
        let detelle_ticket = [];
        let detelle_pago = [];
        let status_invoice = 0;
        let sCodigo = generateCode(15);
        const ALIASESPERA = '';
        const serie_n = 'B';
        let payloadNewOrder = {
          branch_id: selected.branch_id,
          folio: `${selected.folio}`,
          serie: selected.serie,
          total_bruto: Number((values.total / 1.16).toFixed(2)),
          total_neto: Number(values.total.toFixed(2)),
          status: 1,
          detelle_ticket,
          detelle_pago,
          status_invoice,
          ALIASESPERA,
          serie_n,
        };
        payloadNewOrder.fecha = new Date(selected.fecha);
        payloadNewOrder.codigo = sCodigo;
        currentOrder = await process(SAVE_KEY, 'orders', payloadNewOrder);
      }
      const stringMethod = values.payment_method.split('&');
      const oPaymentMethodCode = stringMethod[0];
      const oPaymentMethodId = stringMethod[1];
      console.log('values', values);
      const stringForm = values.payment_form.split('&');
      const oPaymentFormCode = codeMap[stringForm[0]] ?? stringForm[0];
      const oPaymentFormId = stringForm[1];
      console.log('oPaymentFormCode', stringForm, oPaymentFormCode);

      let resClient = await process(
        GET_KEY,
        'clients',
        {},
        { id: values.cliente }
      );

      let oClienteRegimen = await process(
        FIND_KEY,
        'regimes',
        {},
        { queries: `id=${resClient?.data.regime_id}`, skip: 0 }
      );
      let oInvoiceUse = await process(
        FIND_KEY,
        'invoice-uses',
        {},
        { queries: `id=${resClient?.data.use_id}`, skip: 0 }
      );
      let oBranchRegimen = await process(
        FIND_KEY,
        'regimes',
        {},
        { queries: `id=${branch?.regime_id}`, skip: 0 }
      );

      let oXMLInvoice = {
        order: currentOrder.data,
        client: resClient.data,
        branch: branch,
        email: values.email,
        subtotal: Number((values.total / 1.16).toFixed(2)),
        metodoPago: oPaymentMethodCode,
        formaPago: oPaymentFormCode,
        clientRegime: oClienteRegimen?.data?.data[0].code,
        invoiceUse: oInvoiceUse?.data?.data[0].code,
        branchRegime: oBranchRegimen?.data?.data[0].code,
      };

      console.log(oXMLInvoice);
      let responseInvoice = await useStampInvoicesWithApiKey(oXMLInvoice);
      console.log(responseInvoice);
      if (responseInvoice.status === 200) {
        if (!responseInvoice?.data?.status) {
          message.error(`Error en timbrado ${responseInvoice?.data?.error}`);
          return;
        } else {
          const incidencias =
            responseInvoice?.data?.stamp?.Incidencias?.Incidencia;

          if (Array.isArray(incidencias) && incidencias.length > 0) {
            message.error(`Incidencia: ${incidencias[0].MensajeIncidencia}`);
            return;
          }
          let oInvoice = {
            order_id: currentOrder.data.id,
            branch_id: currentOrder.data.branch_id,
            client_id: resClient.data.id,
            use_id: resClient.data.use_id,
            form_id: oPaymentFormId,
            method_id: oPaymentMethodId,
            invoicing_date: moment().format(),
            stamping_date: moment().format(),
            subtotal: Number((values.total / 1.16).toFixed(2)),
            cfdi: responseInvoice?.data?.stamp?.xml,
            serie: currentOrder.data.serie,
            folio: `${currentOrder.data.folio}`,
            stamping_state: 1,
            status: 1,
            sat_uuid: responseInvoice?.data?.stamp?.UUID,
            complements: `${responseInvoice?.data?.stamp?.UUID}`,
            qr: `${responseInvoice?.data?.stamp?.UUID}`,
            errors: `${responseInvoice?.data?.stamp?.UUID}`,
          };

          let response = await useSaveInvoicesWithApiKey(oInvoice);
          if (response?.status === 201) {
            message.success(
              'Factura timbrada correctamente, enviando email...'
            );

            let oSendInvoice = {
              email: values.email,
              cfdi: btoa(responseInvoice?.data?.stamp?.xml),
              serie: currentOrder.data.serie,
              folio: currentOrder.data.folio,
              fecha_order: currentOrder.data.fecha,
            };
            let rSendInvoice = await useSendInvoicesWithApiKey(oSendInvoice);
            if (rSendInvoice.status === 200) {
              if (rSendInvoice?.data?.status === 200) {
                message.success(rSendInvoice?.data?.message);
              } else {
                message.error(rSendInvoice?.data?.error);
              }
            } else {
              message.error('Error al enviar correo');
            }

            // Marcar orden como facturada SOLO después de que todo fue exitoso
            let newResponse = await process(
              UPDATE_KEY,
              'orders',
              { status_invoice: 1 },
              { id: currentOrder.data.id }
            );

            if (!newResponse?.ok) {
              message.error(`Error al actualizar orden para ${values.email}`);
            } else {
              console.log('updateOldOrder', newResponse);
              message.success(`Factura enviada`);
              nav('/generateInvoice');
            }
          }
        }
      }
      setModal2(false);
      formRef.resetFields();
      setSelected({});
      setModal(false);
      updater();
    } catch (error) {
      console.error('Error general en handleSubmit:', error);
      message.error('Error general al procesar las facturas');
    } finally {
      setModalLoading2(false);
    }
  };

  const handleSearch = () => {
    setSearchFlag(true);
    search.branch_id = branch_id;
    aSearchElements.push({
      label: 'Sucursal',
      name: 'branch_id',
      type: 'branch',
    });
    change(generateQueries(search, aSearchElements));
    aSearchElements.pop();
  };

  const handleSend = async values => {
    setModalLoading2(true);

    let oOrder = await process(
      FIND_KEY,
      'invoices',
      {},
      { queries: `order_id=${selected.id}`, skip: 0 }
    );

    let oSendInvoice = {
      email: values.email,
      cfdi: btoa(oOrder?.data.data[0].cfdi),
      serie: oOrder?.data.data[0].serie,
      folio: oOrder?.data.data[0].folio,
      fecha_order: selected.fecha,
    };
    let rSendInvoice = await useSendInvoicesWithApiKey(oSendInvoice);
    if (rSendInvoice.status === 200) {
      if (rSendInvoice?.data?.status === 200) {
        message.success(rSendInvoice?.data?.message);
      } else {
        message.error(rSendInvoice?.data?.error);
      }
      setModalLoading2(false);
      setModal2(false);
      formRef.resetFields();
    } else {
      message.error('Error al enviar correo');
      setModalLoading2(false);
      setModal2(false);
      formRef.resetFields();
    }
  };

  return (
    <Row
      justify="center"
      style={{ height: '100vh', background: '#f7f7f7' }}
      gutter={[16, 16]}
    >
      <Col span={8} xs={0} sm={0} md={0} lg={8} xl={8}>
        <Row gutter={[24, 24]} style={{ textAlign: 'center' }}>
          <Col span={24} className="hide-on-mobile">
            <img
              src={IMG1}
              alt="Logo"
              style={{ width: '100%', height: 'auto' }}
            />
          </Col>
          <Col className="hide-on-mobile">
            <img
              src={IMG2}
              alt="Logo"
              style={{ width: '100%', height: 'auto' }}
            />
          </Col>
        </Row>
      </Col>
      <Col
        span={8}
        style={{ textAlign: 'center' }}
        xs={24}
        sm={24}
        md={24}
        lg={8}
        xl={8}
      >
        <Row gutter={[16, 0]}>
          <Col span={24}>
            <img
              src={logo}
              alt="Logo"
              style={{ maxWidth: '100%', maxHeight: '100%' }}
            />
          </Col>
          <Col span={24}>
            <div style={{ textAlign: 'justify', fontSize: 12 }}>
              <strong>ATENCIÓN USUARIO</strong>
              <p>
                Para garantizar el éxito en la emisión de sus comprobantes le
                sugerimos ingresar específicamente los datos contenidos en su
                Constancia de Situación Fiscal.
              </p>
              <p>
                Le recordamos que el tiempo para generarlos es dentro de las 72
                hrs posteriores a su consumo.
              </p>
              <p>
                De cualquier forma, ponemos a su disposición la siguiente línea
                de comunicación en donde con gusto será atendido en un horario
                de
                <strong> lunes a viernes de 08:00 a 17:00 hrs</strong>
              </p>
              <p>
                <table style={{ width: '100%', fontWeight: 'bold' }}>
                  <tbody>
                    <tr>
                      <td
                        style={{
                          fontWeight: 'bold',
                          paddingRight: 8,
                          whiteSpace: 'nowrap',
                        }}
                      >
                        Celular:
                      </td>
                      <td
                        style={{
                          fontWeight: 'bold',
                          paddingRight: 8,
                          whiteSpace: 'nowrap',
                        }}
                      >
                        4425614199
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          fontWeight: 'bold',
                          paddingRight: 8,
                          whiteSpace: 'nowrap',
                        }}
                      >
                        Teléfono:
                      </td>
                      <td>4429629214</td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          fontWeight: 'bold',
                          paddingRight: 8,
                          whiteSpace: 'nowrap',
                        }}
                      >
                        Correo electrónico:
                      </td>
                      <td>
                        <a href="mailto:soporte@factora.com.mx">
                          soporte@factora.com.mx
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </p>
              <br />
            </div>
            <h2>Busca tu ticket.</h2>
          </Col>
          <Col span={24}>
            <Button type="dashed" block onClick={() => nav('/generateInvoice')}>
              <ArrowLeftOutlined /> Regresar
            </Button>
          </Col>

          <Col span={24}>
            <h1
              style={{
                color: '#001529',
                textAlign: 'center',
                marginBottom: '20px',
              }}
            >
              Tickets de la sucursal <br /> {branch ? branch.trade_name : ''}
            </h1>

            <SearchBar
              elements={aSearchElements}
              {...{
                handleReset,
                handleSearch,
                search,
                setSearch,
                requiredFields,
              }}
            />
            <TicketActions
              fn={{
                handler: setModalLoading,
                handlerSelected: setSelected,
                selected: selected,
                oClient: client,
              }}
              modal={{
                form: formRef,
                handler: setModal,
                loading: modalLoading,
                submit: handleSubmit,
                visible: modal,
              }}
              modal2={{
                form: formRef,
                handler: setModal2,
                loading: modalLoading2,
                submit: handleSend,
                visible: modal2,
              }}
            />
            {searchFlag === true ? (
              <Table
                columns={aColumns}
                dataSource={loading === false && orders?.data}
                loading={loading}
                pagination={{
                  current: orders?.skip ? orders.skip / 10 + 1 : 1,
                  onChange: e =>
                    change(
                      generateQueries(search, aSearchElements),
                      (e - 1) * orders.limit
                    ),
                  hideOnSinglePage: true,
                  pageSizeOptions: [10],
                  total: orders.total,
                }}
                scroll={{ x: true }}
                rowKey={row => row.id}
              />
            ) : (
              <div
                style={{
                  textAlign: 'center',
                  padding: '40px 20px',
                  color: '#888',
                }}
              >
                <SearchOutlined style={{ fontSize: 50, marginBottom: 20 }} />
                <h3 style={{ color: '#555' }}>Use el buscador</h3>
                <p>para encontrar sus órdenes y facturas</p>
              </div>
            )}
          </Col>
        </Row>
      </Col>
      <Col span={8} xs={0} sm={0} md={0} lg={8} xl={8}>
        <Row gutter={[24, 24]}>
          <Col>
            <img
              src={IMG3}
              alt="Logo"
              style={{ width: '100%', height: 'auto' }}
            />
          </Col>
          <Col>
            <img
              src={IMG4}
              alt="Logo"
              style={{ width: '100%', height: 'auto' }}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
